import {Component, Input, OnChanges, Output} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {DropdownsBase} from '../dropdowns.base';
import {Requests, RequestType} from '../../../../../shared/model/request.model';
import {RequestDialogComponent} from '../../../../../shared/components/request-dialog/request-dialog.component';
import {MessageService} from '../../../../../shared/components/message.service';
import {CiOrderedMultiselectComponent} from '../../../../../../profiler-theme';

@Component({
  selector: 'app-industries-dropdown',
  standalone: true,
  imports: [
    TranslatePipe,
    RequestDialogComponent,
    CiOrderedMultiselectComponent,
  ],
  templateUrl: './industries-dropdown.component.html',
})
export class IndustriesDropdownComponent
  extends DropdownsBase<Requests>
  implements OnChanges {

  @Input() availableIndustries: Requests[] = [];
  @Input() selectedIndustries: string[] = [];
  @Input() required = false;
  @Input() showSorting = true;
  @Input() invalid = false;
  @Input() errorText: string | null = null;

  @Output() industriesChange = this.change;
  override readonly maxItems = 7;
  protected get RequestType() { return RequestType; }
  showModal = false;

  constructor(
    translate: TranslateService,
    liveAnnouncer: LiveAnnouncer,
    messageService: MessageService,
  ) {
    super(translate, liveAnnouncer, messageService);
  }

  ngOnChanges(): void {
    this.init(this.availableIndustries, this.selectedIndustries);
  }

  onAddClick() {
    this.showModal = true;
  }
}
